export const formatCentreAddress = (centre, isDefault = false) => {
  const {
    name,
    address,
    city,
    postalCode,
    country: countryCode,
    phone,
    email,
  } = centre.shippingAddress

  const country = new Intl.DisplayNames(['es'], { type: 'region' }).of(
    countryCode?.length ? countryCode : 'ES',
  )
  const autocompleteAddress = `${name}, ${postalCode} ${city}, ${country}`

  return {
    id: centre.id,
    status: centre?.status,
    isDefault,
    name,
    address,
    city,
    postalCode,
    country: countryCode,
    autocompleteAddress,
    phone,
    email,
  }
}
